import styled from 'styled-components';
import { media } from 'app/utils/style';
import { colors } from 'app/variables';

import IntlPhone from 'app/components/intlPhone';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 1.5rem;
  ${media.mediumDesktop`
    padding: 0;
  `}
  input {
    font-size: 16px;
    border-left: none !important;
    border-right: none !important;
    border-top: none !important;
    padding: 0.6rem 0.3rem;
    border-radius: 0 !important;
  }
`;
export const DetailsForm = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 0;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;
export const WarningNote = styled.div`
  margin-top: 2rem;
  margin-bottom: 1rem;
  color: ${colors.emperor};
  & svg {
    width: 1.75rem !important;
    height: 1.75rem !important;
  }
`;

export const BuyForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  ${media.mediumDesktop`
    border-left: 1px solid ${colors.gallery};
    border-top: none;
    padding-left: 1.5rem;
  `}
`;

export const PhoneInput = styled(IntlPhone)`
  .intl-tel-input.allow-dropdown.separate-dial-code .selected-flag {
    background: transparent;

    &:focus-visible {
      outline: none;
      color: ${colors.pacificBlue};

      .iti-arrow {
        border-top-color: ${colors.pacificBlue};
      }
    }
  }

  & > div {
    width: 100%;
  }

  input {
    padding-inline: initial;

    &:hover {
      border-bottom-color: ${colors.pacificBlue};
    }

    &:focus-visible {
      outline: none;
      border-bottom-color: ${colors.pacificBlue};
    }
  }
`;

export const NameFieldWrapper = styled.div`
  display: flex;
  ${({ direction }) =>
    direction === 'horizontal'
      ? `
    flex-direction: row;
    gap: 1rem;
  `
      : `
    flex-direction: column;
  `}
`;
